import { useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { API } from 'utils/globalApiServices';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const queryFn = async ({ uuid }) => {
  const url = `v2/roleplay/view-assign/${uuid}`;
  const { data } = await API.get(url);
  return data || {};
};

const useViewRealPlayQuery = ({ uuid }) => {
  const { scenario_uuid, setRealPlayRecording } = RealPlayRecordDataHelper();
  const isFirstLoad = useRef(true);

  return useQuery({
    queryFn: () => queryFn({ uuid }),
    queryKey: ['REALPLAY_INFO', uuid],
    onSuccess: (response) => {
      if (!response) return;
      const scenarios = response?.scenarios || [];
      let scenarioSelected;

      if (isFirstLoad.current) {
        // First time: first scenario
        scenarioSelected = {
          ...scenarios?.[0],
          isRecording: false,
          tempVideoUrl: '',
        };
        isFirstLoad.current = false;
      } else {
        //  In invalidations: we rotate using the previous one from the store
        const prevScenarioId = scenario_uuid;

        const indexInScenarios = scenarios.findIndex((s) => s?.uuid === prevScenarioId);

        if (indexInScenarios >= 0 && scenarios.length) {
          const newArr = [...scenarios];

          for (let index = 0; index < newArr.length - indexInScenarios; index++) {
            newArr.unshift(newArr.pop());
          }

          newArr.shift(); // we removed the previous one

          const scenario = newArr.find((s) => {
            const retake = Object.keys(s?.response_retake || {})?.length > 0;
            const video = retake ? s?.response_retake?.video : s?.response?.video || '';
            return !video;
          });

          if (scenario) {
            scenarioSelected = {
              ...scenario,
              isRecording: false,
              tempVideoUrl: '',
            };
            //setScenarioWithSelector(scenarioSelected);
          }
        }
      }

      const realPlayRecording = {
        self_assigned: response?.self_assigned,
        assignment_uuid: response?.uuid,
        assigned_by_user: response?.assigned_by_user,
        roleplay: response?.role_play,
        scenarios,
        rating_criteria: response?.rating_criteria,
        ai_persona: response?.realplay_setting?.ai_persona,
        attitude: response?.realplay_setting?.attitude,
        voice_id: response?.realplay_setting?.ai_persona?.voice_id,
        customer_context: {
          role: response?.realplay_setting?.customer_role,
          industry: response?.realplay_setting?.customer_industry,
          situation: response?.realplay_setting?.customer_situation,
        },
        assigned_to_user: response?.user,
        scenarioSelected,
        sessionInfoTemp: {},
        end_date: response?.deadline,
      };
      setRealPlayRecording(realPlayRecording);
    },
  });
};

export default useViewRealPlayQuery;
